module.exports = {"svg":{"$":{"width":"128","height":"128","xmlns":"http://www.w3.org/2000/svg"},"path":[{"$":{"d":"M73.137 29.08h-9.209 29.7L63.886.093 34.373 29.08h20.49v27.035H27.238v17.948h27.625v27.133h18.274V74.063h27.41V56.115h-27.41V29.08zm-9.245 98.827l27.518-26.711H36.59l27.302 26.71zM.042 64.982l27.196 27.029V38.167L.042 64.982zm100.505-26.815V92.01l27.41-27.029-27.41-26.815z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./~/xml-loader!./src/svg/drag.svg
// module id = 373
// module chunks = 0